import * as types from './types';
import Jump from '../../../helpers/request/jump';

let JumpRequest;

export const jumpConfigRequest = ({ commit }, data) => {
  const { quizId, stepId } = data;
  JumpRequest = new Jump({ quizId, stepId });
};

export const jumpAdd = ({ commit }, data) => {
  const jump = {
    destination_step_id: null,
    options_ids: data.options_ids || null,
  };

  JumpRequest.post(jump, { showLoader: true })
    .then(response => commit(types.JUMP_ADD, { data: response.data }));
};

export const jumpRemove = ({ commit }, data) => {
  JumpRequest.delete(data.id, { showLoader: true })
    .then(() => commit(types.JUMP_REMOVE, { data }));
};

export const jumpSetActive = ({ commit }, jumps) => {
  commit(types.JUMP_SET_ACTIVE, { jumps });
};

export const jumpAddOptionId = ({ commit }, data) => {
  const optionsIds = data.jump.options_ids.slice(0);
  optionsIds.push('');

  JumpRequest.put(data.jump.id, { options_ids: optionsIds }, { showLoader: true })
    .then(response => commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data }));
};

export const jumpRemoveOptionId = ({ commit }, data) => {
  const optionsIds = data.jump.options_ids.slice(0);
  optionsIds.splice(data.index, 1);

  JumpRequest.put(data.jump.id, { options_ids: optionsIds }, { showLoader: true })
    .then(response => commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data }));
};

export const jumpUpdateOptionId = ({ commit }, data) => {
  data.jump.options_ids[data.index] = data.event.target.value;

  JumpRequest.put(data.jump.id, data.jump, { showLoader: true })
    .then(response => commit(types.JUMP_UPDATE_OPTION_ID, { data: response.data }));
};

export const jumpUpdateDestinationStepId = ({ commit }, data) => {
  const config = { showLoader: true };

  JumpRequest.put(data.jump.id, { destination_step_id: data.event.target.value }, config)
    .then(response => commit(types.JUMP_UPDATE_DESTINATION_STEP_ID, { data: response.data }));
};

export const jumpResetActive = ({ commit }) => {
  commit(types.JUMP_RESET_ACTIVE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/jump/actions.js
 **/